export enum OrderCreationError {
  NO_TICKETS = 1,
}
